<template>
    <section class="gmp-section gmp-mb-l">

        <div class="two-column-text">
            <div class="h-c-page">

                <div class="two-column-text__row">
                    <div class="h-c-grid">
                        <div class="h-c-grid__col h-c-grid__col-l--4 h-c-grid__col-l--offset-1 two-column-text__content--left">
                            <h3 class="h-c-headline h-c-headline--one">
                                标准化管理
                            </h3>
                        </div>
                        <div class="h-c-grid__col h-c-grid__col-l--5 h-c-grid__col-l--offset-1 two-column-text__content--right">
                            <div class="h-u-mb-std two-column-text__description">
                                <p>
                                    加盟企业的特点是每个加盟店由不同的加盟商经营，因此标准化管理尤为重要。
                                    系统可以确保所有加盟店按照统一的标准进行采购、库存管理和成本核算，维护品牌的一致性和质量。
                                </p>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="two-column-text__row">
                    <div class="h-c-grid">
                        <div class="h-c-grid__col h-c-grid__col-l--4 h-c-grid__col-l--offset-1 two-column-text__content--left">
                            <h3 class="h-c-headline h-c-headline--one">
                                灵活性与适应性.
                            </h3>
                        </div>
                        <div class="h-c-grid__col h-c-grid__col-l--5 h-c-grid__col-l--offset-1 two-column-text__content--right">
                            <div class="h-u-mb-std two-column-text__description">
                                <p>
                                    系统允许加盟商根据当地市场需求灵活调整采购和库存策略，同时仍能遵循总部的标准化流程。
                                    这种灵活性帮助加盟店在维护品牌标准的同时，适应不同的市场环境。
                                </p>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="two-column-text__row">
                    <div class="h-c-grid">
                        <div class="h-c-grid__col h-c-grid__col-l--4 h-c-grid__col-l--offset-1 two-column-text__content--left">
                            <h3 class="h-c-headline h-c-headline--one">
                                信息透明与决策支持
                            </h3>
                        </div>
                        <div class="h-c-grid__col h-c-grid__col-l--5 h-c-grid__col-l--offset-1 two-column-text__content--right">
                            <div class="h-u-mb-std two-column-text__description">
                                <p>
                                    系统的实时数据共享功能让总部可以随时了解各加盟店的运营情况，及时提供支持和指导。
                                    加盟商也可以通过系统获取详细的成本分析和销售数据，做出更明智的经营决策。
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="two-column-text__row">
                    <div class="h-c-grid">
                        <div class="h-c-grid__col h-c-grid__col-l--4 h-c-grid__col-l--offset-1 two-column-text__content--left">
                            <h3 class="h-c-headline h-c-headline--one">
                                减少管理负担
                            </h3>
                        </div>
                        <div class="h-c-grid__col h-c-grid__col-l--5 h-c-grid__col-l--offset-1 two-column-text__content--right">
                            <div class="h-u-mb-std two-column-text__description">
                                <p>
                                    加盟店通常缺乏直营店的管理资源和经验，
                                    系统的自动化功能可以帮助加盟商降低管理负担，减少运营中的错误和浪费，让他们专注于提高客户服务和销售业绩。
                                </p>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </div>

    </section>
</template>

<script>
    export default {
        name: "WIN_two_column_text"
    }
</script>

<style lang="less">


</style>